import React from 'react';
import { useState, useEffect, Fragment } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as XLSX from "xlsx";
import { configData } from "../../../../config/systemconfigurationconstants";
import UseLambdaInvocations from '../../../../hooks/useLambdaInvocations';
import * as AWS from 'aws-sdk';
import lambdaConfig from '../../../../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../../../../customHooks/useEncryption';
let selectedFileForBulkUser = {};
let fileData = [];

const BulkUserCreation = ({ show, handleClose, usecaseList, userRole, getUserDetails }) => {
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const { encrypt, decrypt } = useEncryption();
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
  };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
secretAccessKey: decrypt(getCookie('sk'))
    });
    const [client, setClient] = useState("");
    const [usecase, setUsecase] = useState("");
    const [clientList, setClientList] = useState([]);

    const [file, setFile] = useState(null);
    const [validated, setValidated] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (client && file) {
            setValidated(false);
            let Users = [], errors = [];
            var header = fileData[0];
            for (let i = 1; i < fileData.length; i++) {
                var user = {};
                if (fileData[i].length != 0) {
                    for (let j = 0; j < fileData[i].length; j++) {
                        user[header[j]] = fileData[i][j];
                    }
                }
                user["IsTwoFactorEnabled"] = (user["IsTwoFactorEnabled"] == "null" || user["IsTwoFactorEnabled"] == "" || user["IsTwoFactorEnabled"] === undefined || user["IsTwoFactorEnabled"] == false) ? false : true;
                user["OTPProvider"] = (user["OTPProvider"] == "null" || user["OTPProvider"] == "" || user["OTPProvider"] === undefined) ? null : user["OTPProvider"].trim();
                if (userRole.some((el) => el.RoleName == user["UserRoleName"])) {
                    Users.push(user);
                } else {
                    errors.push(user);
                }
            }
            console.log("addBulkUsers()", userRole.some((el) => el.RoleName == user["UserRoleName"]))
            console.log("addBulkUsers() - errors", errors);
            console.log("addBulkUsers() - Users", Users);
            if (errors.length == 0) {
                let inputJson = {
                    UserJSON: Users,
                    ClientId: client,
                    UseCaseId: usecase,
                };
                try {
                    const parsedBody = await invokeLambda(configData.ADD_BULK_USERS, {
                        ...lambdaConfig,
                        ...inputJson,
                        SecurityToken: localStorage.getItem('SecurityToken'),
                        // "LoanGuid": localStorage.getItem('loanGuid'),
                    });
                    // if (Array.isArray(parsedBody.Output.impdata)) {
                    if (parsedBody.Status) {
                        toast.success("User Created Sucessfully", {
                            position: "bottom-center",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        handleCloseBulkUser();
                        await getUserDetails();

                        setValidated(false);
                        // setTimeout(() => {
                        //    setDotLoader(true);
                        // }, 1000);
                    } else {
                        handleCloseBulkUser();
                        setValidated(false);
                        toast.error("User Account Already Exists", {
                            position: "bottom-center",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        // setDotLoader(false);
                    }
                } catch (err) {
                    // Handle error if needed
                    //  setDotLoader(false);

                }

            }
        } else {
            setValidated(true);
        }
    };
    const handleCloseBulkUser = () => {
        handleClose();
        setClient("");
        setUsecase("");
        setClientList([]);
        setFile(null);
        setValidated(false);
    }
    const handleUsecaseChange = (value) => {
        setUsecase(value)
        let selectedUsecase = usecaseList.find(x => x.UseCaseID == value);
        let getClientListUnderSelectedUseCase = selectedUsecase ? selectedUsecase.Client : [];
        setClientList(getClientListUnderSelectedUseCase)
    }
    const readExcelFile = (event) => {
        setFile(event.target.files[0]);
        selectedFileForBulkUser = event.target.files[0];
        const target = event.target;
        const reader = new FileReader();
        reader.onload = (e) => {
            const biStr = e.target.result;
            const workbook = XLSX.read(biStr, { type: "binary" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            fileData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            console.log("selectFile() - fileData", fileData);
        };
        reader.readAsBinaryString(target.files[0]);
        //event.target.value = null;
    }
    const addBulkUser = async () => {

    }
    return (
        <Modal show={show} onHide={handleCloseBulkUser} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Bulk User Creation</Modal.Title>
            </Modal.Header>
            <Form noValidate onSubmit={handleSubmit}>
                <Modal.Body>
                    <Row>
                        <Col sm={6}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Select Usecase<span className="required-asterisk">*</span></Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={usecase}
                                    onChange={(e) => handleUsecaseChange(e.target.value)}
                                    isInvalid={validated && !usecase}
                                >
                                    <option value="" disabled>Select Usecase</option>
                                    {usecaseList.map((el) => (
                                        <option value={el.UseCaseID}>{el.UseCaseName}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a Usecase.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label> Select Client<span className="required-asterisk">*</span></Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={client}
                                    onChange={(e) => setClient(e.target.value)}
                                    isInvalid={validated && !client}
                                >
                                    <option value="" disabled>Select Client</option>
                                    {clientList.map((el) => (
                                        <option value={el.ClientID}>{el.ClientName}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please select a client.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3" controlId="formFile">
                        <Form.Label>
                            Upload File<span className="required-asterisk">*</span>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            size="sm"
                            onChange={(e) => readExcelFile(e)}
                            isInvalid={validated && !file}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please upload a file.
                        </Form.Control.Feedback>

                    </Form.Group>



                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={handleCloseBulkUser}>
                        Cancel
                    </Button>
                    <Button variant="primary" type='submit' size='sm'>
                        Add
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BulkUserCreation;